import CodingCardField from "@/components/CodingCardField";
import TD, { TopDownFormProps } from "@/components/forms/TopDownForm";
import { CodeableConceptModel } from "@/data-models/value-models/structs";
import {
  ICodeableConcept,
  IHumanReadableCoding,
} from "@/data-models/value-models/types";
import { useCallback } from "react";
import { assert, type } from "superstruct";

type FieldValues = {
  coding: IHumanReadableCoding | null;
};

type FormOutput = { code: ICodeableConcept };

interface PropertiesFormProps
  extends Omit<TopDownFormProps<FieldValues>, "onSubmit"> {
  chipValueSet?: string;
  onSubmit?: (values: FormOutput) => void;
}
const DEFAULT_VALUESET =
  "http://tiro.health/fhir/ValueSet/snomed-ct-auto-generated";

function PropertiesForm({
  defaultValues,
  onSubmit,
  chipValueSet = DEFAULT_VALUESET,
}: PropertiesFormProps) {
  const handleSubmit = useCallback(
    (values: FieldValues) => {
      assert(values, type({ code: CodeableConceptModel }));
      onSubmit && onSubmit(values);
    },
    [onSubmit]
  );

  return (
    <TD<FieldValues> onSubmit={handleSubmit} defaultValues={defaultValues}>
      {({ control }) => (
        <div>
          <CodingCardField
            name="coding"
            label="Code"
            valueSet={chipValueSet}
            control={control}
          />
          <TD.Submit small>Update chip</TD.Submit>
        </div>
      )}
    </TD>
  );
}

export default PropertiesForm;
